export default "__VITE_ASSET__f027341f__"